import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AudioPreferences } from '@/components/preferences/AudioPreferences';
import { SessionPreferences } from '@/components/preferences/SessionPreferences';
import { PreferencesList } from '@/components/preferences/PreferencesList';
import { CreditsAndBillingTab } from '@/components/user/CreditsAndBillingTab';
import { Settings, Music, Clock, List, Coins } from 'lucide-react';

const PreferencesPage = () => {
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'audio';

  return (
    <div className="container mx-auto p-6 max-w-6xl">
      <div className="mb-8">
        <h1 className="text-3xl font-bold flex items-center gap-3">
          <Settings className="h-8 w-8 text-primary" />
          Preferences
        </h1>
        <p className="text-muted-foreground mt-2">
          Customize your meditation experience, manage credits, and control your subscription
        </p>
      </div>

      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="audio" className="flex items-center gap-2">
            <Music className="h-4 w-4" />
            Audio
          </TabsTrigger>
          <TabsTrigger value="sessions" className="flex items-center gap-2">
            <Clock className="h-4 w-4" />
            Sessions
          </TabsTrigger>
          <TabsTrigger value="saved" className="flex items-center gap-2">
            <List className="h-4 w-4" />
            Saved Preferences
          </TabsTrigger>
          <TabsTrigger value="credits" className="flex items-center gap-2">
            <Coins className="h-4 w-4" />
            Credits & Billing
          </TabsTrigger>
        </TabsList>

        <TabsContent value="audio" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Audio Preferences</CardTitle>
              <CardDescription>
                Customize your audio experience including voice, background music, and soundscapes
              </CardDescription>
            </CardHeader>
            <CardContent>
              <AudioPreferences />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="sessions" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Session Preferences</CardTitle>
              <CardDescription>
                Set your default session settings and meditation preferences
              </CardDescription>
            </CardHeader>
            <CardContent>
              <SessionPreferences />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="saved" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Saved Preferences</CardTitle>
              <CardDescription>
                View and manage all your saved preferences and their confidence levels
              </CardDescription>
            </CardHeader>
            <CardContent>
              <PreferencesList />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="credits" className="mt-6">
          <CreditsAndBillingTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default PreferencesPage;